import { ErrorWithDetails } from '@utility/checkout-utils';

import { GlobalApiErrorSchema } from '../../schemas/error';

import { EMPTY_RETURN } from './getErrorCodeAndMessage.constants';

export const getErrorCodeAndMessage = (error: unknown) => {
  const isGlobalApiError = GlobalApiErrorSchema.safeParse(error);

  if (isGlobalApiError.success) {
    return {
      errorCode: isGlobalApiError.data.data.code,
      errorMessage: isGlobalApiError.data.data.message,
    };
  }

  if (error instanceof TypeError && !('data' in error)) {
    return {
      errorCode: error.name,
      errorMessage: error.message,
    };
  }

  if (
    error instanceof TypeError ||
    (error instanceof Error && !('data' in error))
  ) {
    return {
      errorCode: error.name,
      errorMessage: error.message,
    };
  }

  if (error instanceof ErrorWithDetails) {
    return {
      errorCode: error.name,
      errorMessage: error.message,
    };
  }

  return EMPTY_RETURN;
};
